// Obtém as informações de uma categoria/subcategoria com base no ID
function getCategoryInfos(catID) {
  let catFind = false;
  if (categoriasHome && categoriasHome.length > 0) {
    categoriasHome.forEach((cat) => {
      if (cat['subcategories'] && cat['subcategories'].length > 0) {
        cat['subcategories'].forEach((sub) => {
          if (sub.id == catID) {
            catFind = sub;
            return catFind;
          }
        });
      }
      if (cat.id == catID) {
        catFind = cat;
        return catFind;
      }
    });
  }
  return catFind;
}

// Popula a seção
function populateCategorias($parent, section, action = 'insert') {
  if ($parent.length > 0 && section) {
    // Atualiza a seção (Remove antes para ser criada novamente)
    if (action === 'update') {
      const $sectionUpd = $('#' + section.id);
      if ($sectionUpd.length > 0) {
        $sectionUpd.html('');
        $sectionUpd.remove();
      }
    }

    // Exibe seção
    const showSection = section['show'];
    const showSectionClass = !showSection ? 'd-none' : '';

    // Grid
    const colsDesktop = section['cols-desktop'] || 6;
    const colsTablet = section['cols-tablet'] || 4;
    const colsMobile = section['cols-mobile'] || 3;

    // Itens
    let itensHTML = `<div class="carousel carousel-arrows-circle carousel-infinite-mb carousel-categorias" data-cols-desktop="${colsDesktop}" data-cols-tablet="${colsTablet}" data-cols-mobile="${colsMobile}" data-aos="fade-up" data-aos-offset="0"></div>`;
    let $itens = $(itensHTML);
    section['lista'].forEach((item) => {
      // Url do bloco
      let catUrl;
      if (item['category'] != '' && item['category'] != 'none') {
        const catInfos = getCategoryInfos(item['category']);
        catUrl = catInfos['url'];
      } else {
        catUrl = item['url'];
      }
      // Ícone
      const itemIcon = getSvgIcon(item['category']);
      // HTML do bloco
      let itemHTML = `
      <div class="carousel-item categoria-wrp">
        <a href="${catUrl}" class="categoria link-arrow-hv img-zoom">
          <figure class="img img-circle categoria-img">
            <img src="${item['img']}" alt="${item['titulo']}" width="250px" height="250px">
          </figure>
          <div class="categoria-infos">
            <div class="link link-arrow arrow-slide"><span>${item['titulo']}</span> ${getSvgIcon('arrow-right')}</div>
          </div>
        </a>
      </div>`;
      const $item = $(itemHTML);
      $itens.append($item);
    });

    // Estrutura da seção
    let sectionHTML = `
    <section id="${section['id']}" data-sec-type="categorias" class="home-section categorias bg-image ${showSectionClass}">
      <div class="carousel-sec-top">
        <div class="container">
          <div class="row catalogo-titulo-wrp" data-aos="fade-up" data-aos-offset="0">
            <div class="grid-12 catalogo-titulo-content center">
              <h2 class="title home-title md-text">${section['titulo']}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="carousel-sec-content">
        <div class="container">
          ${$itens[0].outerHTML}
        </div>
      </div>
      <div class="carousel-sec-bottom">
        <div class="container">
          <div class="row">
            <div class="grid-12"></div>
          </div>
        </div>
      </div>
    </section>`;

    // Cria o elemento
    let $section = $(sectionHTML);

    // Estilos
    if (Object.keys(section.styles).length > 0) {
      Object.keys(section.styles).forEach((styleVar) => {
        $section[0].style.setProperty('--' + styleVar, section.styles[styleVar]);
      });
    }

    // Ordem da seção
    $section[0].style.setProperty('--order', section['order']);
    $section[0].style.setProperty('order', section['order']);

    // Plano de fundo (Imagem)
    if (section['bg-type'] == 'image') {
      $section[0].style.setProperty('background-image', `url('${section['bg-image']}')`);
    }
    // Plano de fundo (Gradiente)
    else if (section['bg-type'] == 'gradient') {
      $section[0].style.setProperty('background-image', section['bg-gradient']);
    }

    $parent.append($section);

    // Plugins
    setTimeout(() => {
      categoriasDestroySlick();
      categoriasInitSlick();
    }, 100);
  }
}
